'use client';
import { useState } from 'react';

const PORTAL_ID = '44722511';
const FORM_GUID = '2bb82176-1a25-4ed6-b99f-63f2b82cd34a';

const NewsletterForm = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error

  const handleSubmit = async (e) => {
    e.preventDefault();
    const email_value = email.trim();
    if (!email_value) return;
    setStatus('loading');

    try {
      const res = await fetch(
        `https://api.hsforms.com/submissions/v3/integration/submit/${PORTAL_ID}/${FORM_GUID}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            fields: [{ name: 'email', value: email_value }],
            context: {
              pageUri: window.location.href,
              pageName: document.title,
            },
          }),
        }
      );

      if (res.ok) {
        setStatus('success');
        setEmail('');
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className='footer-newsletter-success' role='status' aria-live='polite'>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M20 6L9 17l-5-5"/>
        </svg>
        You&rsquo;re on the list. We&rsquo;ll be in touch.
      </div>
    );
  }

  return (
    <form className='footer-newsletter-fields' onSubmit={handleSubmit}>
      <input
        className='footer-newsletter-input'
        type='email'
        required
        placeholder='Email'
        aria-label='Email address'
        value={email}
        onChange={e => {
          setEmail(e.target.value);
          if (status === 'error') setStatus('idle');
        }}
      />
      <button
        className='footer-newsletter-btn'
        type='submit'
        disabled={status === 'loading'}
      >
        {status === 'loading' ? 'Signing up…' : 'Sign Up'}
      </button>
      {status === 'error' && (
        <p className='footer-newsletter-error' role='alert'>Something went wrong. Please try again.</p>
      )}
    </form>
  );
};

export default NewsletterForm;
